import * as React from 'react';
import { useState } from 'react';

export type GameSettingsProps = {
    discards: number;
    quick: boolean;
    onPlay: (discards: number, quick: boolean) => void;
}

export function GameSettings(props: GameSettingsProps) {
    const [discards, setDiscards] = useState(props.discards);
    const [quick, setQuick] = useState(props.quick);

    return (
        <div className='game-settings message'>
            <header>New Game</header>
            <div>
                <label>Discards </label>
                <select value={discards} onChange={e => setDiscards(parseInt(e.target.value))}>
                    <option value="5">5 - Easy</option>
                    <option value="4">4 - Medium</option>
                    <option value="3">3 - Hard</option>
                </select>
            </div>
            <div>
                <label><input type="checkbox" checked={quick} onChange={e => setQuick(e.target.checked)}/>Quick Game (25 cards)</label>
            </div>
            <div><button onClick={() => props.onPlay(discards, quick)}>Play</button></div>
        </div>
    );
}
